import { ExcelLikeGrid } from "../../../shared/excel-grid/components/ExcelLikeGrid";
import type { ExcelGridColumn } from "../../../shared/excel-grid/models/excel-grid.models";
import type { AdminPnlGridProps, AdminPnlRow } from "../../models/admin-pnl.models";
import { ADMIN_PNL_COLUMNS } from "../../utils/admin-pnl.constants";
import { ignoreAdminPnlCellCommit } from "../../utils/admin-pnl.utils";
import { useMemo } from "react";

const AdminPnlGrid = ({ rows, disabled, onSync }: AdminPnlGridProps) => {
  const columns = useMemo<ExcelGridColumn[]>(
    () => [
      {
        key: "__actions",
        label: "Action",
        editable: false,
        filterable: false,
        sortable: false,
        minWidth: 155,
        maxWidth: 155,
        renderCell: (value) => {
          const row = value as AdminPnlRow;
          return (
            <button
              type="button"
              data-test={`admin-pnl-sync-${row.TC_CODE}-${row.VOYAGE_NO}`}
              aria-label={`Sync vessel name for ${row.TC_CODE}, voyage ${row.VOYAGE_NO}`}
              disabled={disabled || !row.CAN_SYNC}
              title={row.SYNC_BLOCK_REASON ?? "Preview the vessel-name changes"}
              onClick={() => onSync(row)}
              className="inline-flex h-8 items-center border border-green px-2 text-xs font-semibold text-green hover:bg-[#E9F4F3] disabled:cursor-not-allowed disabled:opacity-50 dark:hover:bg-gray-700"
            >
              Sync vessel name
            </button>
          );
        },
      },
      ...ADMIN_PNL_COLUMNS,
    ],
    [disabled, onSync],
  );

  return (
    <ExcelLikeGrid
      rows={rows}
      columns={columns}
      dataTest="admin-pnl-grid"
      onCellCommit={ignoreAdminPnlCellCommit}
      editingDisabled
      showHeadersWhenEmpty
      emptyLabel="No PnL voyages match your search."
      rowHeight={44}
    />
  );
};

export default AdminPnlGrid;
